import { Entity, LiveData } from '@toeverything/infra';

import type { FolderTemplateListStore } from '../store/folder-list';

export class FolderTemplateList extends Entity {
  constructor(public listStore: FolderTemplateListStore) {
    super();
  }

  public isTemplate$(folderId: string) {
    return LiveData.from(this.listStore.watchTemplateFolder(folderId), false);
  }

  public templateFolderIds$ = LiveData.from(
    this.listStore.watchTemplateFolders(),
    [] as { id: string }[]
  ).map(list => list.map(property => property.id));

  public isTemplate(folderId: string) {
    return this.listStore.isTemplateFolder(folderId);
  }

  public setTemplate(folderId: string, isTemplate: boolean) {
    this.listStore.setTemplateFolder(folderId, isTemplate);
  }

  public getTemplateFolderIds() {
    return this.listStore.getTemplateFolderIds();
  }
}
